// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2KVij","form":"styles_form__15mKv"};